export default "/profile/images/bitrixUAthree.png?237cafe0ffe47032a75b8c1ac4faefc4";